module.exports = __webpack_public_path__ + "bcf23f62ff1a07682555482781712e2e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/4_D#2.mp3
// module id = 120
// module chunks = 0